import * as React from 'react'
import { Link, Tooltip } from 'cs-kevlar-react'

interface CopyTextLinkProps {
  link: string
  tooltip: string
}

export const CopyTextLink: React.FunctionComponent<CopyTextLinkProps> = ({
  link,
  tooltip,
}) => {
  const [tooltipText, setTooltipText] = React.useState(tooltip)

  const copyText = () => {
    if ((navigator as any).clipboard) {
      // Modern browsers
      ;(navigator as any).clipboard.writeText(link)
      setTooltipText('Copied.')
    } else if ((window as any).clipboardData) {
      // Legacy browsers (IE)
      ;(window as any).clipboardData.setData('text', link)
      setTooltipText('Copied.')
    } else {
      // Unsupported
      setTooltipText('Manual copy required.')
    }
  }

  return (
    <Tooltip
      title={tooltipText}
      aria-label={tooltipText}
      placement="bottom"
      arrow
    >
      <span>
        <Link variant="body1" target="_blank" rel="noopener" onClick={copyText}>
          {link}
        </Link>
      </span>
    </Tooltip>
  )
}
